import { createContext, useState } from 'react'
import { CustomerData } from '@/actions/userActions'

const defaultValue: CustomerData = {
  id: 0,
  alias: '',
  receipt_name: '',
  address: '',
  partner_id: 0
}

export const CustomerContext = createContext<{
  customerData: CustomerData
  updateCustomerData: (customerData: CustomerData) => void
}>({ customerData: defaultValue, updateCustomerData: () => {} })

export const CustomerContextProvider = (props: React.PropsWithChildren) => {
  // Define the state variable that holds the global variable
  const customerDataJSON = window.localStorage.getItem('customer_data')
  const [customerData, setCustomerData] = useState(
    customerDataJSON ? JSON.parse(customerDataJSON) : defaultValue
  )

  // Provide the global variable and the update function as the value for the context
  const contextValue = {
    customerData,
    updateCustomerData: setCustomerData
  }

  return (
    <CustomerContext.Provider value={contextValue}>
      {props.children}
    </CustomerContext.Provider>
  )
}
